import { useState } from "react";
import { Download, Save, Trash2, Mail, PackageCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, downloadFile } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const QuoteActions = ({ id, doc, setDoc, busy, save, remove, customerEmail }) => {
  const [confirm, setConfirm] = useState(false);
  const [working, setWorking] = useState(false);
  const isOrder = doc?.type === "order";

  const email = async () => {
    if (!customerEmail) return toast.error("This customer has no email address. Add one in Customers.");
    setWorking(true);
    try {
      const d = isOrder ? doc : await save(false);
      if (!d) return;
      const { data } = await api.post(`/quotes/${d.id}/email`);
      toast.success(`Emailed PDF to ${data.to}`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setWorking(false);
    }
  };

  const convert = async () => {
    setWorking(true);
    try {
      const d = await save(false);
      if (!d) return;
      const { data } = await api.post(`/quotes/${d.id}/convert`);
      setDoc(data);
      toast.success(`Order ${data.order_number} created. Stock updated.`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setWorking(false);
      setConfirm(false);
    }
  };

  const dis = busy || working;
  return (
    <div className="flex flex-wrap gap-2">
      {id && <Button variant="outline" onClick={remove} data-testid="quote-delete-btn"><Trash2 className="h-4 w-4" /></Button>}
      <Button variant="outline" disabled={dis} onClick={email} data-testid="quote-email-btn"><Mail className="mr-1 h-4 w-4" /> Email customer</Button>
      {isOrder ? (
        <Button disabled={dis} onClick={() => downloadFile(`/quotes/${doc.id}/pdf`, `${doc.order_number}.pdf`)} className="bg-[#1BA3E0] hover:bg-[#1590C8]" data-testid="order-pdf-btn">
          <Download className="mr-1 h-4 w-4" /> Download PDF
        </Button>
      ) : (
        <>
          <Button variant="outline" disabled={dis} onClick={() => save(false)} data-testid="quote-save-btn"><Save className="mr-1 h-4 w-4" /> Save</Button>
          <Button variant="outline" disabled={dis} onClick={() => setConfirm(true)} data-testid="quote-convert-btn"><PackageCheck className="mr-1 h-4 w-4" /> Convert to order</Button>
          <Button disabled={dis} onClick={() => save(true)} className="bg-[#1BA3E0] hover:bg-[#1590C8]" data-testid="quote-save-pdf-btn"><Download className="mr-1 h-4 w-4" /> Save & download PDF</Button>
        </>
      )}
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Convert to sales order?</AlertDialogTitle>
            <AlertDialogDescription>The quote will be saved and turned into an order. Stock counts for every item on it will be reduced. Orders can't be edited afterwards.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={convert} className="bg-[#01195D]" data-testid="quote-convert-confirm-btn">Convert</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
